module.exports = __webpack_public_path__ + "media/images/flags/cw-d2b0e987a0cf17cbd234af006785604c.svg";